import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errDetail } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(errDetail(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[var(--surface)] border border-[var(--border-strong)] rounded-xl px-4 py-3 text-sm text-[var(--text)] outline-none focus:border-[var(--accent)] focus:ring-2 focus:ring-[var(--accent)]/20 transition-colors duration-300 placeholder:text-[var(--muted)]";

  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[var(--surface)] border border-[var(--border)] rounded-3xl p-10 fade-up" style={{ boxShadow: "var(--shadow)" }} data-testid="login-card">
        <img src="/exotic-india-wordmark.webp" alt="Exotic India" className="h-10 w-auto mb-6 mx-auto object-contain" data-testid="login-logo" />
        <h1 className="font-serif-display font-semibold text-3xl mb-2">Welcome back</h1>
        <p className="text-sm text-[var(--text-2)] mb-8">Claude, ChatGPT & Gemini — one workspace.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-medium text-[var(--text-2)] block mb-1.5">Email</label>
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@team.com" />
          </div>
          <div>
            <label className="text-xs font-medium text-[var(--text-2)] block mb-1.5">Password</label>
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-xs text-[var(--error)] bg-[var(--error)]/10 border border-[var(--error)]/20 rounded-xl px-3 py-2.5">{error}</p>}
          <button data-testid="login-submit-button" type="submit" disabled={loading}
            className="w-full rounded-full text-white font-semibold text-sm py-3 transition-colors duration-300 disabled:opacity-50"
            style={{ background: "var(--accent)" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--accent-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "var(--accent)")}>
            {loading ? "Signing in…" : "Continue"}
          </button>
        </form>
        <p className="text-xs text-[var(--muted)] mt-6 text-center">Accounts are managed by your admin</p>
      </div>
    </div>
  );
}
